import { NgForOf, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { Store } from '@ngrx/store';

import { OrderAdditionalShipmentsComponent } from '@components/orders/manage-orders/production-flow/order-shipping-details/order-additional-shipments/order-additional-shipments.component';

import { ClientsApiActions } from '../../../../../@store/clients/clients.actions';
import { selectCountries } from '../../../../../@store/clients/clients.selectors';
import { singleOrderDetails } from '../../../../../@store/orders/orders.model';

@Component({
  selector: 'ciwc-order-shipping-details',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    NgIf,
    NgForOf,
    OrderAdditionalShipmentsComponent,
  ],
  standalone: true,
  templateUrl: './order-shipping-details.component.html',
  styleUrl: './order-shipping-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderShippingDetailsComponent implements OnInit {
  private readonly store = inject(Store);
  readonly countries = this.store.selectSignal(selectCountries);

  @Input() parentForm!: FormGroup;
  @Input() orderDetails!: singleOrderDetails;
  @Input() createShipmentGroup!: () => FormGroup;

  get shippingDetailsGroup(): FormGroup {
    return this.parentForm.get('shippingDetails') as FormGroup;
  }

  trackByCountryName(index: number, country: { name: string }): string {
    return country.name;
  }

  readonly patchReady = computed(() => {
    return !!this.countries()?.length && !!this.orderDetails?.shippingDetails?.[0];
  });
  @Input() viewDisable!: boolean;

  constructor() {
    effect(() => {
      if (this.patchReady()) {
        const details = this.orderDetails.shippingDetails[0] as Record<string, any>;
        const patch: any = {};
        Object.keys(this.shippingDetailsGroup.controls).forEach((key) => {
          if (details[key] !== undefined) {
            patch[key] = details[key];
          }
        });
        this.shippingDetailsGroup.patchValue(patch);
      }
    });
  }

  ngOnInit(): void {
    if (!this.viewDisable) {
      this.loadCountries();
    }
  }

  private loadCountries(): void {
    this.store.dispatch(ClientsApiActions.loadCountries({ payload: { limit: -1, sort: 'name' } }));
  }
}
